import { AsyncValidatorFn, FormControl, ValidatorFn } from '@angular/forms';
import { LorenzFormMixin } from './lorenz-form.mixin';
import { LorenzFormPayload } from './interfaces/lorenz-control-payload.interface';

export class LorenzFormControl<T = any> extends LorenzFormMixin(FormControl) {
	// prettier-ignore
	constructor(
		formState?: T,
		validatorOrOpts?: ValidatorFn | ValidatorFn[] | null,
		asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
		payload?: LorenzFormPayload
	) {
		super(formState, validatorOrOpts, asyncValidator);

		this.payload = {
			...(payload ?? {}),
			initValue: formState
		};

		// console.log('LorenzFormControl', this, this.payload);
	}
}
